import { GraduationCap, School, Users, HeartPulse, Award } from "lucide-react";
import { Reveal } from "../lib/anim";

const PROGRAMS = [
  { icon: GraduationCap, title: "Community Health Education", body: "Workshops promoting hygiene, preventive healthcare, nutrition, and healthy living.", span: "lg:col-span-2", accent: true },
  { icon: School, title: "School Health Initiative", body: "Distribution of hygiene kits and educational materials to students." },
  { icon: Users, title: "Youth Volunteer Leadership", body: "Training and coordinating youth volunteers to serve their communities." },
  { icon: HeartPulse, title: "Community Wellness Events", body: "Health fairs, screenings, and educational outreach with healthcare providers.", span: "lg:col-span-2", accent: true },
  { icon: Award, title: "Scholarships", body: "For students pursuing careers in healthcare, public health, nursing, and community service." },
];

export const Programs = () => (
  <section id="programs" data-testid="programs" className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
    <Reveal>
      <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-brand-blue font-bold mb-4">Where We're Headed</p>
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-brand-ink max-w-3xl leading-[1.02]">
        A growing constellation of care.
      </h2>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {PROGRAMS.map((p, i) => {
        const Icon = p.icon;
        return (
          <Reveal key={i} delay={i * 0.05} className={p.span || ""}>
            <div
              data-testid={`program-card-${i}`}
              className={`group h-full rounded-2xl p-8 border transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${
                p.accent ? "bg-brand-blue text-white border-brand-blue" : "bg-white hairline"
              }`}
            >
              <div className={`h-12 w-12 rounded-xl flex items-center justify-center mb-6 ${p.accent ? "bg-white/15" : "bg-brand-blue/8"}`}>
                <Icon className={`h-6 w-6 ${p.accent ? "text-white" : "text-brand-blue"}`} />
              </div>
              <h3 className={`font-display text-2xl mb-3 ${p.accent ? "text-white" : "text-brand-ink"}`}>{p.title}</h3>
              <p className={p.accent ? "text-white/75 leading-relaxed" : "text-brand-ink/60 leading-relaxed"}>{p.body}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
